import { CSSProperties } from "react";

import { useTheme, useWindowDimensions } from "@hooks";
import { constants, spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;

  const styles: Record<string, CSSProperties> = {
    container: {
      backgroundColor: theme.dashboard.beneficiarySsnBanner.background,
      borderRadius: constants.radius.view,
      boxSizing: "border-box",
      marginBottom: isMobile ? spacing.xs : spacing.m,
      marginLeft: isMobile ? "auto" : spacing.m,
      marginRight: isMobile ? "auto" : spacing.m,
      maxWidth: isMobile ? 350 : undefined,
      padding: spacing.xs,
      width: isMobile ? 350 : undefined,
    },
    button: {
      alignItems: "center",
      background: "none",
      border: "none",
      cursor: "pointer",
      display: "flex",
      flexDirection: "row",
      padding: 0,
      width: "100%",
    },
    icon: {
      flexShrink: 0,
      marginRight: spacing.m,
    },
    body: {
      flex: 1,
      fontWeight: 500,
      textAlign: "left",
    },
  };

  return {
    styles,
    iconFill: theme.dashboard.beneficiarySsnBanner.icon,
  };
};
